// import React, { lazy, Suspense } from 'react'

// const Lazy = lazy(() => import(/* webpackChunkName: "App" */ './App'))

// export default function App(props) {
//   return (
//     <Suspense fallback={<div />}>
//       <Lazy {...props} />
//     </Suspense>
//   )
// }

import Component from './App'

export default Component
